import * as R from 'ramda'

import {
  CommonIncidentId,
  EventStatusId,
  IncidentId,
} from '@collector/sportsapi-client-legacy'

import { BlockedIncidentsMap } from './blockedIncidentsMap'

export function getCommonBlockedIncidents(
  pocketIncidents: PocketIncidents,
  morePocketIncidents: PocketIncidents,
): Set<IncidentId> {
  const allIncidents = [...pocketIncidents, ...morePocketIncidents]
  const incidentIds = allIncidents.map(({ incidentId }) => incidentId)
  const filteredIncidentIds = R.without(
    [CommonIncidentId.TechnicalProblems],
    incidentIds,
  )
  return new Set(filteredIncidentIds)
}

export function getBlockedPocketIncidentsMap(
  pocketIncidents: PocketIncidents,
  morePocketIncidents: PocketIncidents,
  blockedStatuses: EventStatusId[],
): BlockedIncidentsMap {
  const commonBlockedIncidents = getCommonBlockedIncidents(
    pocketIncidents,
    morePocketIncidents,
  )

  const blockedPocketIncidentsMap = new Map(
    blockedStatuses.map((status) => [status, commonBlockedIncidents]),
  )

  return blockedPocketIncidentsMap
}

export type PocketIncidents = {
  incidentId: IncidentId
  title: string
}[]

export type PocketIncidentsConfig = {
  pocketIncidents: PocketIncidents
  morePocketIncidents?: PocketIncidents
  blockedPocketIncidentsMap?: BlockedIncidentsMap
}
